"use client";

import { useLayoutEffect, type ReactNode } from "react";

export function FirstRunLightSurface({ children }: { children: ReactNode }) {
  useLayoutEffect(() => {
    const root = document.documentElement;

    const enforce = () => {
      const hadDark = root.classList.contains("dark");
      const needsLightScheme = root.style.colorScheme !== "light";
      if (!hadDark && !needsLightScheme) {
        return;
      }
      if (hadDark) {
        root.classList.remove("dark");
      }
      if (needsLightScheme) {
        root.style.colorScheme = "light";
      }
    };

    enforce();

    const observer = new MutationObserver(() => {
      enforce();
    });
    observer.observe(root, {
      attributes: true,
      attributeFilter: ["class", "style"],
    });

    return () => {
      observer.disconnect();
      root.classList.remove("dark");
      root.style.colorScheme = "light";
    };
  }, []);

  return children;
}
